import { render, staticRenderFns } from "./cargo-bike-insurance.vue?vue&type=template&id=21bbb5f5&scoped=true"
import script from "./cargo-bike-insurance.vue?vue&type=script&lang=js"
export * from "./cargo-bike-insurance.vue?vue&type=script&lang=js"
import style0 from "./cargo-bike-insurance.vue?vue&type=style&index=0&id=21bbb5f5&prod&lang=scss&scoped=true"
import style1 from "./cargo-bike-insurance.vue?vue&type=style&index=1&id=21bbb5f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbb5f5",
  null
  
)

export default component.exports